import { render, staticRenderFns } from "./Cheating_management_standard.vue?vue&type=template&id=7634244d&scoped=true"
import script from "./Cheating_management_standard.vue?vue&type=script&lang=js"
export * from "./Cheating_management_standard.vue?vue&type=script&lang=js"
import style0 from "./Cheating_management_standard.vue?vue&type=style&index=0&id=7634244d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634244d",
  null
  
)

export default component.exports